import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { SmallLoading } from '@components/loading';
import { scale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import { TileComponent } from '@v2/context/ProductionBatch/types';
import ReadyPcsQuantity from '@components/common/ReadyPcsV2/components/ReadyPcsQuantity';
import { isBatchLinked, getQuantityProduced } from '@v2/context/ProductionBatch/tile/helpers';
import { InlineErrorBoundary, InlineErrorFallbackSize } from '@v2/components/errorBoundary';

interface ReadyPcsBlockProps extends Pick<TileComponent, 'batch'> {
  batchStatisticsLoaded: boolean;
  C: ColorFunction;
}

const ReadyPcsBlock: FC<ReadyPcsBlockProps> = ({ batchStatisticsLoaded, batch, C }) => {
  const batchLinked = isBatchLinked(batch?.links);
  const quantityProduced = getQuantityProduced(batch) ?? undefined;

  if (batchLinked && !batchStatisticsLoaded) {
    return (
      <View style={{ height: scale(43), justifyContent: 'center' }}>
        <SmallLoading />
      </View>
    );
  }

  return (
    <View style={{ gap: scale(3) }}>
      <InlineErrorBoundary screenName="BatchTileReadyPcsBlock" size={InlineErrorFallbackSize.Micro}>
        <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('Ready')}</Text>
        <View style={{ alignSelf: 'flex-end' }}>
          <ReadyPcsQuantity
            C={C}
            batch={batch}
            quantityProduced={quantityProduced}
            fontForQuantityProduced="Time 1"
            colorForQuantityProduced="Label/Light/Primary"
            fontForQuantityTarget="Time 3"
            colorForQuantityTarget="Label/Light/Tertiary"
          />
        </View>
      </InlineErrorBoundary>
    </View>
  );
};

export { ReadyPcsBlock };
